<template>
  <div style="height: 100vh; display: flex; flex-direction: column;justify-content: space-between;">
    <div class="top-div">
      <div @click="handleBack" style="font-size: 22px;margin: 5px 10px 0 0;">
        <van-icon name="arrow-left" />
      </div>
      <div class="top-div-title">{{memo ? memo : name}}</div>
    </div>
    <message class="message-div" :sessionId="sessionId" :accountId="accountId" />

    <div class="bottom-div">
      <div class="material">
        <div @click="handleUrl('/wordsPage')">话术库</div>
        <div @click="handleUrl('/contentPage')">内容库</div>
        <div v-if="isQueryType === 0" @click="handleData">客户资料</div>
        <div @click="handleAdd" class="add">+</div>
      </div>
      <div class="send">
        <van-field v-model="inputText" center clearable onblur="onblur" onfocus="onfocus">
          <template #button>
            <van-button size="small" type="info" @click="handleSend">发送</van-button>
          </template>
        </van-field>
      </div>
      <!-- @keydown.enter.native="pushKeyword($event)" -->
      <!--      <input v-model="inputText" @keydown.enter.native="pushKeyword($event)" type="textarea" style="width: 70%"/>-->
      <!--      <van-button size="small" type="info" @click="handleSend">发送</van-button>-->
    </div>

    <!-- 相册 popup -->
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '30%' }">
      <div class="popup">
        <uploadImg @selectFile='selectFile' :sessionId="sessionId"></uploadImg>
      </div>
    </van-popup>
    <!-- 相册 popup -->
    <van-popup v-model="showPopupCustomer" position="bottom" :style="{ height: '70%' }">
      <customer :href='href' type='chat' :customerDetails='customerDetails' :theContactId="contactId"></customer>
    </van-popup>
  </div>
</template>

<script>
import message from './message'
import uploadImg from "../../components/uploadImg/index"
import customer from "../chatToolBar/customerPage.vue"
import bus from '@/utils/vueBus.js'
export default {
  components: { message, uploadImg, customer },
  data () {
    return {
      contactId: '',
      sessionId: '',
      accountId: '',
      inputText: '', // 发送文本
      showPopup: false,
      type: -1,
      File: [],
      href: {
        corpId: this.$store.state.auth.corpId
      },
      isQueryType: 0,
      showPopupCustomer: false,
      customerDetails: {}
    }
  },
  created () {
    this.isQueryType = Number(this.$route.query.type)
    this.contactId = this.$route.query.contactId
    this.sessionId = this.$route.query.sessionId
    this.accountId = this.$route.query.accountId
    this.memo = this.$route.query.memo
    this.name = this.$route.query.name || ''
    this.inputText = this.$route.query.inputText || ''

    this.getCustomerDetails()
  },
  methods: {
    handleUrl (url) {
      this.$router.push({ path: url, query: { type: this.isQueryType, contactId: this.contactId, sessionId: this.sessionId, accountId: this.accountId, memo: this.memo, name: this.name } })
    },
    handleData () {
      this.showPopupCustomer = true
    },
    //获取customerDetails
    getCustomerDetails () {
      this.$http
        .get("/scrm/v1/qw-client/m/findDtoById", {
          params: {
            id: this.contactId
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.customerDetails = res.data
          }
        })
    },
    // 返回会话列表
    handleBack () {
      this.$router.push('/sessionList')
    },
    pushKeyword (event) {
      console.log('ddd:', event)
      if (event.keyCode === 13) {
        this.text = this.text + '\n'
      }
    },
    // 发送消息
    handleSend () {
      console.log('发送内容：', this.inputText)
      if (this.inputText !== '') {
        let obj = {
          contentType: 0,
          content: this.inputText,
          sessionId: this.sessionId,
        }
        bus.$emit('wxbSendText', obj)
        this.inputText = ''
      }
    },
    onblur () {
      console.log('失去焦点')
    },
    onfocus () {
      console.log('得动焦点')
    },
    // 调起相册
    handleAdd () {
      this.showPopup = true
    },
    // 发送文件
    selectFile (val) {
      console.log(val, 'val')
      this.File = val
      let suffix = val.file.name.substring(val.file.name.lastIndexOf('.') + 1).toLowerCase()
      if (suffix === 'jpg' || suffix === 'png') {
        this.type = 1
      } else if (suffix === 'mp4') {
        this.type = 2
      } else if (suffix === 'mp3') {
        this.type = 3
      } else {
        //  if (suffix === 'xls' || suffix === 'xlsx' || suffix === 'doc' || suffix === 'docx' || suffix === 'ppt' || suffix === 'pptx' || suffix === 'rar' || suffix === 'gzip' || suffix === 'zip' || suffix === 'arj' || suffix === 'tar' || suffix === '7z' || suffix === 'txt' || suffix === 'pdf')
        this.type = 4
      }
      this.$http.post(`/scrm/v1/qw-session/m/sendOtherMsg`, {
        fileName: this.File.file.name, //文件名
        filePath: this.type === 4 ? this.File.url : null, //文件url链接
        sessionId: this.sessionId, //会话id
        imgUrl: this.type === 1 ? this.File.url : null, //图片路径
        thumbPath: this.type === 2 ? 'https://scrm-1259589177.cos.ap-guangzhou.myqcloud.com/scrm-send/1611659180469.jpg' : null, //封面
        type: this.type, //类型
        videoPath: this.type === 2 ? this.File.url : null, //视频链接
        content: this.type === 3 ? this.File.url : null, //音频链接
        length: '1000', //语言长度
        voiceType: '2' //语音格式
      }).then(res => {
        if (res.code === 1) {
          this.$toast('发送成功')
          this.$toast.clear()
          this.showPopup = false
        } else {
          this.$toast(`${res.msg}`)
          this.$toast.clear()
        }
      })
    },
  }
}

</script>
<style lang="less" scoped>
.top-div {
  /*position: relative;*/
  /*top: 0;*/
  z-index: 9999;
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 0 0 12px;
  background-color: #3974c4;
  > div {
    line-height: 50px;
    font-size: 18px;
    color: #fff;
  }
}

.message-div {
  /*position: relative;*/
  /*top: 60px;*/
  /*bottom: 42px;*/
  flex: 1;
  width: 100%;
  /*padding-bottom: 20px;*/
  overflow: auto;
  background-color: rgb(245, 246, 247);
}
.bottom-div {
  /*position: relative;*/
  /*bottom: 0;*/
  width: 100%;
  //   height: 50px;
  .material {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    padding: 0 0 20px;
    background: rgb(245, 246, 247);
    > div {
      height: 25px;
      padding: 0 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      background: #fff;
      color: #969799;
      border-radius: 12px;
      margin-right: 15px;
      margin-bottom: 20px;
    }
    .add {
      width: 27px;
      height: 27px;
      padding: 0;
      border-radius: 50%;
      font-size: 22px;
    }
  }
  .send {
    /deep/ .van-field {
      background-color: #fff;
      /deep/ .van-field__control {
        background-color: white !important;
        height: 30px !important;
      }
    }
    /deep/ .van-button--small {
      padding: 5px 20px;
    }
    .van-button {
      border-radius: 5px;
    }
  }
}
.popup {
  padding: 10px;
  > div {
    width: 80px;
    font-size: 12px;
    color: #333;
    text-align: center;
  }
  /deep/ .van-uploader__upload {
    width: 50px;
    height: 50px;
    margin: 0 auto 10px;
  }
}
</style>
